var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.trainings)?_c('OrganismAccordion',{attrs:{"list":_vm.groupedData}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }